module.exports = __webpack_public_path__ + "static/image 9-bbfffec7b05225328039523becb1e449.png";